type tBlobUrlEntry = { blob: Blob; holders: Set<object> };

const urlsByBlob = new WeakMap<Blob, string>();
const entries = new Map<string, tBlobUrlEntry>();
const urlsByHolder = new Map<object, Set<string>>();

export const getBlobUrl = (blob: Blob): string | undefined => urlsByBlob.get(blob);

export const setBlobUrlHolder = (holder: object, urls: readonly (string | null | undefined)[]) => {
  const next = new Set(urls.filter((url): url is string => !!url && entries.has(url)));
  const previous = urlsByHolder.get(holder) ?? new Set<string>();
  for (const url of next) entries.get(url)?.holders.add(holder);
  for (const url of previous) {
    if (next.has(url)) continue;
    const entry = entries.get(url);
    if (!entry) continue;
    entry.holders.delete(holder);
    if (entry.holders.size) continue;
    entries.delete(url);
    urlsByBlob.delete(entry.blob);
    URL.revokeObjectURL(url);
  }
  if (next.size) urlsByHolder.set(holder, next);
  else urlsByHolder.delete(holder);
};

export const releaseBlobUrlHolder = (holder: object) => setBlobUrlHolder(holder, []);

export const createHeldBlobUrl = (blob: Blob, holder: object): string => {
  let url = urlsByBlob.get(blob);
  if (!url) {
    url = URL.createObjectURL(blob);
    urlsByBlob.set(blob, url);
    entries.set(url, { blob, holders: new Set() });
  }
  const held = urlsByHolder.get(holder) ?? new Set<string>();
  held.add(url);
  urlsByHolder.set(holder, held);
  entries.get(url)?.holders.add(holder);
  return url;
};
